// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider-module--divider--2jyw0","thickness4":"Divider-module--thickness-4--3Iwbn"};